import React from "react";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import DefaultAvatar from "@/assets/common/ic_default_avatar.svg";
import OriginPlateIcon from "@/assets/summary/ic_origin_plate.svg?react";

export interface IDisplayUserInfo {
  userId?: string;
  displayName: string;
  avatarUrl?: string;
  avatarIndex?: number;
}

interface IProps {
  userInfo: IDisplayUserInfo;
  className?: string;
}
const Avatar: React.FC<IProps> = ({ className, userInfo }) => {
  const { userId, displayName, avatarUrl, avatarIndex } = userInfo;

  return displayName === "MAXHUB会议平板" ? (
    <OriginPlateIcon className={`${className}`} />
  ) : !userId || avatarUrl ? (
    <img
      src={avatarUrl || DefaultAvatar}
      className={`${className} rounded-full no_drag`}
    />
  ) : (
    <SpeakerAvatar
      className={`${className}`}
      avatarIndex={avatarIndex}
      speakerName={displayName}
    />
  );
};

export default Avatar;
